import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card card-xxl-stretch" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title fw-bolder text-black" }, " Recuento total de privados de libertad en recintos penitenciarios a nivel Nacional. ", -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "card-body p-0" }
const _hoisted_5 = { class: "card-p position-relative" }
const _hoisted_6 = { class: "row m-0" }
const _hoisted_7 = { class: "col bg-light-warning px-6 py-8 rounded-2 me-7 mb-7" }
const _hoisted_8 = { class: "svg-icon svg-icon-3x svg-icon-warning d-block my-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("a", { class: "text-warning fw-bold fs-6" }, " Ingresos diarios: 32 ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("a", { class: "text-warning fw-bold fs-6" }, " Traslados diarios: 32 ", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("a", { class: "text-warning fw-bold fs-6" }, " Salidas diarias: 32 ", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = { class: "col bg-light-primary px-6 py-8 rounded-2 mb-7" }
const _hoisted_16 = { class: "svg-icon svg-icon-3x svg-icon-primary d-block my-2" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("a", { class: "text-primary fw-bold fs-6" }, " Ingresos semanales: 32 ", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("a", { class: "text-primary fw-bold fs-6" }, " Traslados semanales: 32 ", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("a", { class: "text-primary fw-bold fs-6" }, " Salidas semanales: 32 ", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = { class: "row m-0" }
const _hoisted_24 = { class: "col bg-light-danger px-6 py-8 rounded-2 me-7" }
const _hoisted_25 = { class: "svg-icon svg-icon-3x svg-icon-danger d-block my-2" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("a", { class: "text-danger fw-bold fs-6" }, " Ingresos mensuales: 32 ", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("a", { class: "text-danger fw-bold fs-6" }, " Traslados mensuales: 32 ", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("a", { class: "text-danger fw-bold fs-6" }, " Salidas mensuales: 32 ", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_32 = { class: "col bg-light-success px-6 py-8 rounded-2" }
const _hoisted_33 = { class: "svg-icon svg-icon-3x svg-icon-success d-block my-2" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("a", { class: "text-success fw-bold fs-6" }, " Ingresos anuales: 32 ", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("a", { class: "text-success fw-bold fs-6" }, " Traslados anuales: 32 ", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("a", { class: "text-success fw-bold fs-6" }, " Salidas anuales: 32 ", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([`bg-secondary`, "card-header border-0 py-5"])
    }, _hoisted_3),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_apexchart, {
        height: "300px",
        type: "bar",
        options: _ctx.options,
        series: _ctx.series
      }, null, 8, ["options", "series"]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen032.svg" })
            ]),
            _hoisted_9,
            _hoisted_10,
            _hoisted_11,
            _hoisted_12,
            _hoisted_13,
            _hoisted_14
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("span", _hoisted_16, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen032.svg" })
            ]),
            _hoisted_17,
            _hoisted_18,
            _hoisted_19,
            _hoisted_20,
            _hoisted_21,
            _hoisted_22
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("span", _hoisted_25, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen032.svg" })
            ]),
            _hoisted_26,
            _hoisted_27,
            _hoisted_28,
            _hoisted_29,
            _hoisted_30,
            _hoisted_31
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("span", _hoisted_33, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen032.svg" })
            ]),
            _hoisted_34,
            _hoisted_35,
            _hoisted_36,
            _hoisted_37,
            _hoisted_38,
            _hoisted_39
          ])
        ])
      ])
    ])
  ]))
}